import { Button, ButtonProps } from '@mui/material'
import { useNavigate } from 'react-router'
import { useAppSelector } from 'store/configureStore'

export const RFQInboxButton = (props: ButtonProps) => {
  const navigate = useNavigate()
  const partyId = useAppSelector((state) => state.user.organizationContext.id)

  if (!partyId) {
    return null
  }

  return (
    <Button
      {...props}
      onClick={() => {
        navigate(`/app/rfq-inbox`)
      }}
    >
      RFQ Inbox
    </Button>
  )
}
